function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1018_310677)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M66.653 8.61133H98.6889C105.997 8.61133 111.933 14.539 111.933 21.8385V56.7677C111.933 59.8448 109.437 62.3407 106.352 62.3407H58.9902C55.9088 62.3407 53.4087 59.8448 53.4087 56.7677V21.8385C53.4087 14.539 59.3406 8.61133 66.653 8.61133Z",
  fill: "#1F75DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.3716 62.3496V31.3223H87.9662V62.3496",
  fill: "#E6F8FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.6666 46.4171C83.9444 46.4171 84.9787 45.3829 84.9787 44.1051C84.9787 42.8272 83.9444 41.793 82.6666 41.793C81.3887 41.793 80.3545 42.8272 80.3545 44.1051C80.3545 45.3829 81.3887 46.4171 82.6666 46.4171Z",
  fill: "#1F75DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.6666 58.4308C83.9444 58.4308 84.9787 57.3966 84.9787 56.1187C84.9787 54.8409 83.9444 53.8066 82.6666 53.8066C81.3887 53.8066 80.3545 54.8409 80.3545 56.1187C80.3545 57.3966 81.3887 58.4308 82.6666 58.4308Z",
  fill: "#1F75DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.095 20.8986C100.095 6.86789 90.3253 0 82.3847 0C70.273 0 65.23 12.74 65.23 20.8986C65.23 26.7023 68.2088 37.3738 72.6321 41.7971L82.513 31.9291L92.3938 41.7971C96.924 37.2712 100.095 26.8433 100.095 20.8986Z",
  fill: "#1B4D89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.2048 6.73136C78.8717 2.06871 86.4533 2.06871 91.1202 6.73136C95.7871 11.394 95.7871 18.9671 91.1202 23.6297L82.6625 32.0789L74.2048 23.6297C69.5379 18.9671 69.5379 11.394 74.2048 6.73136Z",
  fill: "#0E3163"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.0579 20.1289H2.92751C1.31069 20.1289 0 21.4396 0 23.0564V75.4866C0 77.1034 1.31069 78.4141 2.92751 78.4141H43.0579C44.6747 78.4141 45.9854 77.1034 45.9854 75.4866V23.0564C45.9854 21.4396 44.6747 20.1289 43.0579 20.1289Z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 75.5642C0 71.4742 3.31214 68.1621 7.40211 68.1621H38.5833C42.6689 68.1621 45.9854 71.4742 45.9854 75.5642C45.9854 77.1369 44.7075 78.4148 43.1348 78.4148H2.85058C1.27785 78.4148 0 77.1369 0 75.5642Z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.9854 22.9795L42.1689 31.0226C41.1945 33.0783 39.1175 34.3904 36.8396 34.3904H9.14579C6.86789 34.3904 4.79513 33.0783 3.81644 31.0226L0 22.9795C0 21.4068 1.27785 20.1289 2.85058 20.1289H43.1348C44.7075 20.1289 45.9854 21.4068 45.9854 22.9795Z",
  fill: "#1F75DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.7168 66.5762C58.7338 66.5762 57.8492 67.1745 57.4774 68.0848L55.7422 72.3842C55.5072 72.9654 55.5072 73.6107 55.7422 74.192L57.4774 78.4913C57.8449 79.4059 58.7296 80 59.7168 80H64.7384C65.7214 80 66.606 79.4016 66.9779 78.4913L67.9694 76.0382H78.252L80.9658 73.3244L78.252 70.6106H75.9912L74.4825 72.1192L73.2773 70.914L72.0721 72.1192L70.5635 70.6106H68.0035L66.9864 68.0933C66.6189 67.1788 65.7342 66.5847 64.747 66.5847H59.7253L59.7168 66.5762ZM63.4221 72.2902C64.1102 72.9782 64.1145 74.0979 63.4221 74.786C62.734 75.4784 61.6143 75.4784 60.9262 74.7903C60.2382 74.0979 60.2382 72.9782 60.9262 72.2902C61.6143 71.6021 62.734 71.6021 63.4221 72.2902Z",
  fill: "#C5AE21"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1018_310677"
}, /*#__PURE__*/React.createElement("rect", {
  width: 111.929,
  height: 80,
  fill: "white"
})));

function SvgPackP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 80,
    viewBox: "0 0 112 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgPackP);
export default __webpack_public_path__ + "static/media/pack-p.c3b8ee08.svg";
export { ForwardRef as ReactComponent };